import axios, { AxiosResponse, AxiosError } from 'axios'

interface GoogleTokenVerifyResponse {
  issued_to?: string
  audience?: string
  scope?: string
  expires_in?: number
  error?: string
  error_description?: string
}

export const GeneralAPI = {
  verifyGoogleSheetToken: async (token: string) => {
    try {
      const response: AxiosResponse<GoogleTokenVerifyResponse> = await axios({
        method: 'GET',
        url: `https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${token}`,
      })

      return { data: response.data }

    } catch (error) {
      const axiosError = error as AxiosError<GoogleTokenVerifyResponse>
      return {
        data: null,
        error: axiosError.response?.data?.error || axiosError.message || 'Unknown error occurred',
      }
    }
  }
}
